import React from "react";
import Select, { SelectOption } from "@amzn/meridian/select";
import Column from "@amzn/meridian/column";
import DatePicker from "@amzn/meridian/date-picker";
import Input from "@amzn/meridian/input";
import Textarea from "@amzn/meridian/textarea";
import Text from "@amzn/meridian/text";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "../../../utils/formattingUtils";

export const MailInfoSectionFieldsRenderer = ({
    section,
    formData,
    handleChange,
    searchQuery,
    setSearchQuery,
    getDisabledDates,
    stateOptions,
    searchRegExp,
}) => {
    switch (section.type) {
        case "select":
            return (
                <Select
                    label={section.label}
                    value={formData[section.field] || ""}
                    onChange={value => handleChange(section.field, value)}
                    disabled={section?.disabled}
                    error={
                        section?.errorMessage
                            ? formData[section.field] === undefined ||
                              formData[section.field].length === 0
                            : undefined
                    }
                    errorMessage={
                        section?.errorMessage
                            ? formData[section.field] === undefined ||
                              formData[section.field].length === 0
                                ? section?.errorMessage
                                : undefined
                            : undefined
                    }
                >
                    {section.options.map(option => (
                        <SelectOption
                            key={option.value}
                            value={option.value}
                            label={option.label}
                        />
                    ))}
                </Select>
            );
        case "select-search":
            return (
                <Select
                    label={section.label}
                    popoverMaxHeight={200}
                    searchQuery={searchQuery}
                    onSearch={setSearchQuery}
                    value={formData[section.field] || ""}
                    onChange={value => handleChange(section.field, value)}
                    placeholder={section.options.placeholder}
                    width={"100%"}
                >
                    {section.options
                        .filter(option => !searchQuery || searchRegExp.test(option.label))
                        .map(option => {
                            return <SelectOption value={option.value} label={option.label} />;
                        })}
                    {!section.options.filter(
                        option => !searchQuery || searchRegExp.test(option.label)
                    ).length ? (
                        <Column alignmentVertical="center" spacing="300" spacingInset="600">
                            <Text alignment="center">No results</Text>
                        </Column>
                    ) : null}
                </Select>
            );
        case "date":
            return (
                <DatePicker
                    value={moment(formData[section.field]).format(DEFAULT_DATE_FORMAT) || ""}
                    onChange={value => handleChange(section.field, value)}
                    label={section.label}
                    disabledDates={value => getDisabledDates(section, value)}
                />
            );
        case "input":
            return (
                <Input
                    value={formData[section.field] || ""}
                    onChange={value => handleChange(section.field, value)}
                    type="text"
                    label={section.label}
                    prefix={section.prefix}
                    suffix={section.suffix}
                />
            );
        case "input-number":
            return (
                <Input
                    value={formData[section.field] || ""}
                    onChange={value => handleChange(section.field, value)}
                    type="number"
                    label={section.label}
                    prefix={section.prefix}
                    suffix={section.suffix}
                />
            );
        case "textarea":
            return (
                <Textarea
                    value={formData[section.field] || ""}
                    onChange={value => handleChange(section.field, value)}
                    label={section.label}
                />
            );
        case "address":
            return (
                <>
                    <Input
                        value={formData.streetAddress || ""}
                        onChange={value => handleChange("streetAddress", value)}
                        label="Street address"
                    />
                    <Input
                        value={formData.city || ""}
                        onChange={value => handleChange("city", value)}
                        label="City"
                    />
                    <Select
                        label={"State"}
                        popoverMaxHeight={200}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        value={formData.state || ""}
                        onChange={value => handleChange("state", value)}
                        width={"100%"}
                    >
                        {stateOptions
                            .filter(option => !searchQuery || searchRegExp.test(option.label))
                            .map(option => {
                                return <SelectOption value={option.value} label={option.label} />;
                            })}
                        {!stateOptions.filter(
                            option => !searchQuery || searchRegExp.test(option.label)
                        ).length ? (
                            <Column alignmentVertical="center" spacing="300" spacingInset="600">
                                <Text alignment="center">No results</Text>
                            </Column>
                        ) : null}
                    </Select>
                    <Input
                        value={formData.zipCode || ""}
                        onChange={value => handleChange("zipCode", value)}
                        label="ZIP Code"
                    />
                </>
            );
        default:
            return null;
    }
};
